import { render, staticRenderFns } from "./langModal.vue?vue&type=template&id=585d7b04&scoped=true&"
import script from "./langModal.vue?vue&type=script&lang=js&"
export * from "./langModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585d7b04",
  null
  
)

export default component.exports